
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/stats-explained",
      function () {
        return require("private-next-pages/stats-explained/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/stats-explained"])
      });
    }
  